<template>
    <div class="layout-head bg-white">
        <div class="head-left-box">
            <div class="mobile-cd" v-if="isMoile" @click="$emit('showMenu')">
                <i class="el-icon-more"></i>
            </div>
        </div>
        <div class="head-right-box">
            <div class="head-icon">
                <i class="el-icon-bell"></i>
            </div>
            <div class="head-icon">
                <i class="el-icon-bell"></i>
            </div>
            <el-dropdown @command="handle" trigger="click">
                <div class="user-info">
                    <img src="http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLf5tnz2N6KnMamKCA3Vnb4a7B6VNMo9g9JOkScJgI6rR5cVzbGyy8V9c9uxYuTPB2ictZqjtbd8ZA/132">
                    <div class="user-info-text">
                        <h4>炖萝卜<i class="ds1"></i></h4>
                        <p>白金代理商</p>
                    </div>
                </div>
                <el-dropdown-menu slot="dropdown" style="width: 130px">
                    <el-dropdown-item><i class="el-icon-setting"></i> 个人中心</el-dropdown-item>
                    <el-dropdown-item><i class="el-icon-setting"></i> 账户设置</el-dropdown-item>
                    <el-dropdown-item disabled><i class="el-icon-setting"></i> 测试</el-dropdown-item>
                    <el-dropdown-item command="loginout"><i class="el-icon-setting"></i> 退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            showMobileMenu: false
        }
    },
    computed: {
        siderBar () {
            return this.$store.state.app.sidebar
        },
        isMoile () {
            return this.$store.state.app.device === 'mobile'
        }
    },
    watch: {
        siderBar (value) {
            this.showMobileMenu = false
        }
    },
    methods: {
        handle (command) {
            if (command === 'loginout') {
                this.loginout()
            }
        },
        loginout () {
            this.$confirm('真的要注销登录吗 ?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '退出成功!'
                })
                sessionStorage.setItem('token', '')
                this.$router.push('/user/login')
            })
        }
    }
}
</script>
